import React, { useState, useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import _get from "lodash/get"

import { getConfig } from "@/constants/config"
import { getProductsById } from "@/components/cart/cartHelper"
import { getShortenedUrl, getUserPersona } from "@/utils/helper"
import { getProductsBySku } from "@/components/sharedCart/shareCartHelper"

import { selectCartState } from "@/store/features/cartSlice"

import PairsWellWithView from "@/components/PairsWellWith/PairsWellWith.view"
import MissingImage from "@/public/images/image-missing.png"
import { apim } from "@/constants/api"
import { selectPdpState } from "@/store/features/pdpSlice"

const PairsWellWith = props => {
  const info = useRef({})
  const { cart: activeCart } = useSelector(selectCartState)
  const {
    pdp: {
      sku: skuId = "",
      recommendedAccessories = [],
      productBrand = "",
      productNo = "",
    } = {},
  } = useSelector(selectPdpState)
  const {
    data: pairsWellWithdata = {},
    data: {
      aemDataList = [],
      dataFrom = null,
      mboxIdList = [],
      title = "",
      presetConfigs = "",
      swatchUrl = "",
    } = {},
  } = props

  const initialState = {
    productRecommendedId: [],
    productData: [],
    pairsProductProps: [],
    ProductCategory: "",
    productName: "",
    source: null,
    brandName: "",
  }
  const [dataSource, setDataSource] = useState(null)
  const [state, setState] = useState(initialState)
  const [recommendedAccessoriesLocal, setRecommendedAccessoriesLocal] =
    useState([])
  const [productBrandLocal, setProductBrandLocal] = useState("")

  const fetchFromTarget = async (mboxes, sku) => {
    // TODO: GBH-16163 Update to use APIM Endpoint
    for (let i = 0; i < mboxes.length; i++) {
      try {
        const res = await apim.get("search/target-recommendations", {
          params: {
            mboxid: mboxes[i],
            sku: sku,
          },
        })

        if (res && res.data?.recommendedItems?.length > 0) {
          const skus = res.data.recommendedItems.map(product => {
            if (product.sku) {
              return product.sku.replace("K-", "")
            }
          })
          if (skus.length > 0) {
            const productData = await getProductsBySku(skus)
            setState({ ...state, productData })
          }
          break
        }
      } catch (err) {
        console.error(err)
      }
    }
  }

  const fetchRecentlyViewed = async () => {
    const viewedItems = localStorage.getItem("recently-viewed")
      ? JSON.parse(localStorage.getItem("recently-viewed"))
      : []
    if (
      viewedItems?.length > 0 &&
      viewedItems?.length >= info.current?.recentlyViewedMin
    ) {
      const productData = []
      const products = await getProductsById(viewedItems)
      // Pushing into new array to maintain recently viewed order
      viewedItems.forEach(id => {
        const product = products.find(p => p.id === id)
        if (product) {
          productData.push(product)
        }
      })
      setState({ ...state, productData })
    }
  }

  const getRecommendedProducts = productNo => {
    const { recommendedSkus = [] } =
      aemDataList.find(e => e.primarySku.includes(productNo)) || {}
    if (dataFrom === "fromAem" && recommendedSkus.length) {
      getProductsBySku(recommendedSkus).then(productData => {
        setState({ productData, recommendedSkus })
      })
    } else {
      setState({ productData: [], recommendedSkus })
    }
  }

  const displayComponent = (productlength = 0) => {
    if (!productlength) {
      return false
    }
    if (dataSource === "recently-viewed") {
      if (
        activeCart?.lineItems?.length === 0 &&
        state.productData?.length >= info.current?.recentlyViewedMin
      )
        return true
      return false
    }
    return true
  }
  const createPairsData = async () => {
    const pairsProductProps = []
    state.productData.forEach(product => {
      const pData = {}
      getConfig().then(async config => {
        const { general } = config
        pData.pdpUrl = await getShortenedUrl(general.pagePathPDP ?? "/")
      })
      const masterVariant = _get(product, "masterVariant", [])
      const attributes = _get(masterVariant, "attributes", [])
      pData.name = _get(
        attributes.find(attr => attr.name === "ProductBrandName"),
        "value",
        ""
      )
      pData.slug = _get(product, `slug[${info.current.locale}]`, "")
      pData.description = _get(
        product,
        `description[${info.current.locale}]`,
        ""
      )
      pData.variants = _get(product, "variants", [])
      pData.colors = []
      pData.variants.forEach(variant => {
        const discountinuedDate = _get(
          variant.attributes.find(
            attrib => attrib.name === "RegionDiscontinuedDate"
          ),
          "value",
          ""
        )
        if (!discountinuedDate || Date.parse(discountinuedDate) > Date.now()) {
          pData.colors.push(variant)
        }
      })
      pData.sku = _get(masterVariant, "sku", "")
      pData.productCategory = _get(
        attributes.find(attr => attr.name === "ProductLocalCategory"),
        "value",
        ""
      )

      if (masterVariant.images && masterVariant.images.length > 0)
        pData.images = _get(masterVariant, "images[0].url", "")
      else pData.images = MissingImage

      const priceObj = masterVariant.prices.find(
        item =>
          item.value.currencyCode === info.current.currencyCode &&
          item.customerGroup?.obj?.key === info.current.persona
      )
      pData.price = (
        Number(_get(priceObj, "value.centAmount", 0)) / 100
      ).toFixed(2)
      pData.discountedPrice = (
        Number(_get(priceObj, "discounted.value.centAmount", 0)) / 100
      ).toFixed(2)
      pairsProductProps.push(pData)
    })
    setState({ ...state, pairsProductProps })
  }
  useEffect(() => {
    getConfig().then(config => {
      const locale = _get(config, "internationalization.locale", "")
      const currencySign = _get(config, "internationalization.currencySign", "")
      const currencyCode = _get(config, "internationalization.currencyCode", "")
      const siteName = _get(config, "general.siteName", "")
      const persona = getUserPersona()
      const recentlyViewedMin = _get(config, "general.recentlyViewedMin", 1)

      info.current = {
        locale: locale,
        currencyCode: currencyCode,
        currencySign: currencySign,
        recentlyViewedMin: recentlyViewedMin,
        siteName: siteName,
        persona: persona,
      }
    })
  }, [])

  useEffect(() => {
    setState({
      source: dataFrom,
      mbox: mboxIdList,
    })
    setDataSource(dataFrom)
  }, [pairsWellWithdata])

  useEffect(() => {
    if (skuId && aemDataList && aemDataList.length)
      getRecommendedProducts(productNo, skuId)
  }, [skuId, aemDataList, productNo])

  useEffect(() => {
    if (dataSource === "ct") {
      if (recommendedAccessoriesLocal.length) {
        getProductsById(recommendedAccessoriesLocal).then(productData =>
          setState({ ...state, productData, brandName: productBrandLocal })
        )
      }
    } else if (dataSource === "mbox") {
      fetchFromTarget(state.mbox, skuId)
    } else if (
      dataSource === "recently-viewed" &&
      activeCart?.lineItems?.length === 0
    ) {
      fetchRecentlyViewed()
    }
  }, [
    activeCart,
    skuId,
    recommendedAccessoriesLocal,
    productBrandLocal,
    dataSource,
  ])

  useEffect(() => {
    if (recommendedAccessories && recommendedAccessories.length > 0) {
      setRecommendedAccessoriesLocal(recommendedAccessories)
    }
  }, [recommendedAccessories])
  useEffect(() => {
    if (productBrand) {
      setProductBrandLocal(productBrand)
    }
  }, [productBrand])

  useEffect(() => {
    if (state.productData?.length) createPairsData()
  }, [state.productData])

  return (
    displayComponent(state.productData?.length) && (
      <PairsWellWithView
        pairsProductProps={state.pairsProductProps}
        source={dataSource}
        title={title ? title.replace("{{category}}", state.brandName) : ""}
        currencySign={info.current.currencySign}
        presetConfigs={presetConfigs}
        swatchUrl={swatchUrl}
      />
    )
  )
}

export default PairsWellWith
